import { DEFAULT, FEMALE, MALE } from "../template/state/modules/layout";
import { getFloor, setFloor } from "@asosteam/asos-web-store-presentation-node";
import { setGender } from "../template/state/modules/layout/actions";

const isValidGender = gender => [FEMALE, MALE].includes(gender);

const getTokenGender = tokens => {
  const gender =
    typeof tokens.gender === "string" ? tokens.gender.toLowerCase() : "";
  return isValidGender(gender) ? gender : DEFAULT;
};

const getStateGender = state => state.layout.gender;

const getGender = (state, tokens) => {
  const genders = [getTokenGender(tokens), getFloor(), getStateGender(state)];

  return genders.find(isValidGender) || DEFAULT;
};

const updateGenderCookie = gender => {
  setFloor(gender);
  return gender;
};

export default ({ store, initialState, newState }) => {
  const newGender = updateGenderCookie(getGender(initialState, newState));

  if (getStateGender(initialState) !== newGender) {
    store.dispatch(setGender(newGender));
  }
};
